// Operator-confirmed September 15, 2026; prices updated by the owner
// 2026-11-03 (one sitewide range). Engraving terms, not laser cutting.
const laserEngravingFacts = {
  path: '/laser-engraving-service-nyc/',
  nationalPath: '/services/laser-engraving/',
  metalPath: '/services/metal-engraving/',
  metalProcess: 'MOPA laser',
  reviewedDate: '2026-09-15',
  // Lowest setup, used where one number is needed (schema "from" prices).
  setupFee: 75,
  setupRange: '$75–$150',
  pieceRange: '$10–$35 per piece',
  productionRanges: [
    { label: 'Small flat items', price: 'From $10 per piece' },
    {
      label: 'Bottles, curved or multi-side items',
      price: 'Up to $35 per piece',
    },
  ],
  rush: '+50%',
  workAreas: { metal: '8 × 8 inches', wood: '48 × 36 inches' },
  standardLeadTime: '2–3 weeks',
}

const engravingAreaAnswer = `PrintAWorld’s metal engraving area is up to ${laserEngravingFacts.workAreas.metal}; wood engraving is up to ${laserEngravingFacts.workAreas.wood}. These are engraving areas, not maximum object dimensions. The object’s shape, coating, height, and access to the artwork placement still need review. Ask us about the available area for other materials.`
const engravingTimingAnswer = `Standard laser-engraving lead time at PrintAWorld is ${laserEngravingFacts.standardLeadTime}. Suitable rush projects may be ready as soon as the next day or within a week, subject to project review and availability. For a rush request, be ready to send or drop off your items the same day the job is confirmed. Transit time affects what is possible; confirm the in-hand date with us before sending anything.`
const engravingPriceAnswer = `PrintAWorld charges a ${laserEngravingFacts.setupRange} setup per job, then ${laserEngravingFacts.pieceRange}: small flat items from $10; bottles, curved or multi-side items up to $35. Rush adds 50%. These are planning ranges, not fixed rates or total job prices. Item size, engraving area, quantity and complexity affect the quote.`
const engravingFaqs = [
  {
    question: 'How much does laser engraving in NYC cost?',
    answer: engravingPriceAnswer,
  },
  {
    question: 'How long does laser engraving take? Can you rush my project?',
    answer: engravingTimingAnswer,
  },
  {
    question: 'How large an area can you engrave on metal or wood?',
    answer: engravingAreaAnswer,
  },
  {
    question:
      'Is laser engraving the right choice for a solid black or full-color logo?',
    answer:
      'Not always. An engraved or laser-marked result depends on the material and coating. If you need an opaque black or full-color graphic on an approved aluminum item, metal card, or other object, <a href="/uv-printing-services/">UV printing</a> may be a better fit. Send a photo and the finish you want so we can recommend the process.',
  },
]

module.exports = {
  laserEngravingFacts,
  engravingAreaAnswer,
  engravingTimingAnswer,
  engravingPriceAnswer,
  engravingFaqs,
}
